var _ellipse, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSolrplexIcon = function SvgSolrplexIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "solrplex-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.015,
    height: 24.016
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 4323",
    cx: 12.007,
    cy: 12.008,
    rx: 12.007,
    ry: 12.008
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108504",
    d: "M8.577 23.522a12 12 0 0 1-4.973-2.934h4.973Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108505",
    d: "M8.577 20.586h6.857a1.715 1.715 0 0 0 0-3.431h-5.141a1.715 1.715 0 0 0-1.715 1.715Z",
    "data-fill": "a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108506",
    d: "M1.156 17.15a11.925 11.925 0 0 1-1.034-3.431h8.455v1.715a1.715 1.715 0 0 1-1.715 1.716Z",
    "data-fill": "a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108507",
    d: "M10.293 10.292h8.577a1.715 1.715 0 0 1 0 3.431H8.577v-1.715a1.715 1.715 0 0 1 1.716-1.716Z",
    "data-fill": "a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108508",
    d: "M.122 10.292a11.924 11.924 0 0 1 1.034-3.431h7.421v1.718a1.715 1.715 0 0 1-1.715 1.715Z",
    "data-fill": "a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108509",
    d: "M8.577 6.861h6.857a1.715 1.715 0 0 0 0-3.431h-5.141a1.715 1.715 0 0 0-1.715 1.715Z",
    "data-fill": "a"
  })));
};
export default SvgSolrplexIcon;